export class NotAuthorizedError extends Error {
    statusCode = 403;
    constructor(url: string) {
      super(`User not authorized: ${url}`);
      this.name = 'NotAuthorized';
    }
}
